import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight, HeartHandshake } from "lucide-react";
import { company } from "../mock";
import { Button } from "./ui/button";

const CTASection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="mx-auto max-w-7xl px-4">
        <div className="brand-gradient rounded-[2rem] px-8 py-14 md:px-16 text-center relative overflow-hidden">
          <div className="hero-blob h-64 w-64 bg-white/20 -top-16 -right-10" />
          <div className="relative">
            <div className="inline-grid place-items-center h-14 w-14 rounded-2xl bg-white/15 text-white mx-auto mb-5">
              <HeartHandshake className="h-7 w-7" />
            </div>
            <h2 className="font-display font-extrabold text-3xl md:text-4xl text-white">
              Ready to bring care home?
            </h2>
            <p className="text-white/90 mt-4 max-w-xl mx-auto">
              Talk to our care team today for a free, no-obligation consultation. Hospital & nursing home referrals welcome.
            </p>
            <div className="mt-8 flex flex-wrap gap-4 justify-center">
              <Link to="/contact">
                <Button className="bg-[#2E9E6A] hover:bg-[#23875A] text-white rounded-full h-12 px-7 text-base">
                  Request Home Care <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
              <a href={`tel:${company.phoneRaw}`}>
                <Button className="bg-white text-[#0E5A72] hover:bg-slate-100 rounded-full h-12 px-7 text-base">
                  <Phone className="mr-2 h-4 w-4" /> {company.phone}
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
